import React, { ReactNode } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { reportTrackingEvent } from '../../tracking/thunks'
import { useReportViewEvent } from '../../hooks'
import { ErrorStepIcon } from '../../components/icons/StepIcons/ErrorStepIcon'
import { Button } from '../../components/styled/CosmaButton/CosmaButton'
import { ReduxState } from '../../store/reducers'

export const ErrorStep: React.FC<ReactNode> = (props) => {
  useReportViewEvent({ pageTitle: 'failure_unspecified' })
  const {
    config: { theme },
  } = useSelector((state: ReduxState) => state)

  const dispatch = useDispatch()

  const reloadPage = () => {
    dispatch(
      reportTrackingEvent({
        pageTitle: 'failure_unspecified',
        label: 'restart',
        eventName: 'lead_error',
        inputValue: 'restart',
      })
    )
    window.location.reload()
  }

  return (
    <div
      data-theme='cosma'
      className='grid grid-flex grid-justify-center font-antialiased'
      style={{
        background: theme.background,
        color: theme.text,
      }}
    >
      <div className={'grid-item one-whole'}>
        <ErrorStepIcon />
      </div>
      <h2
        data-testid='error-step-headline'
        className='grid-item one-whole align-center font-normal font-line-xs palm-font-xl padding-top-m padding-horizontal-l'
      >
        Es ist ein Fehler aufgetreten.
      </h2>
      <div className='grid-item one-whole input-text-container margin-bottom-xxl align-center padding-horizontal-l'>
        <div className={'align-center'}>
          <div>Bitte versuchen Sie es erneut.</div>
          <div className={'margin-top-xxl'}>
            <Button
              data-testid='error-step-reload-page-button'
              onClick={reloadPage}
              appearance={'primary'}
              className={'palm-one-whole'}
              primary={theme.primary}
              textColor={theme.text}
              secondaryLight={theme.secondaryLight}
            >
              Maklervergleich erneut starten
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
